import dayjs, { Dayjs } from "utils/dayjs"

import { Guid } from "@/types"
import AmountWithCurrency, { IAmountWithCurrencyDto } from "./AmountWithCurrency"


export interface IGetAssetInvoiceOutgoingDto {
    id: Guid
    reservationId: Guid
    from: string
    to?: string
    purpose: string
    assignedAmount: IAmountWithCurrencyDto
    rentalFeeAmount?: IAmountWithCurrencyDto
    orderNumber?: string
    daysInUse?: number | null
    isAdHoc?: boolean
}


export class AssetInvoiceOutgoing {
    id: Guid
    reservationId: Guid
    from: Dayjs
    to?: Dayjs
    assignedAmount: AmountWithCurrency
    rentalFeeAmount?: AmountWithCurrency
    orderNumber?: string
    daysInUse?: number | null
    isAdHoc?: boolean

    constructor(dto: IGetAssetInvoiceOutgoingDto) {
        this.id = dto.id
        this.reservationId = dto.reservationId
        this.from = dayjs(dto.from, "YYYY-MM-DD")
        this.to = dto.to ? dayjs(dto.to, "YYYY-MM-DD") : undefined
        this.assignedAmount = new AmountWithCurrency(dto.assignedAmount)
        this.rentalFeeAmount = dto.rentalFeeAmount && new AmountWithCurrency(dto.rentalFeeAmount)
        this.orderNumber = dto.orderNumber
        this.daysInUse = dto.daysInUse
        this.isAdHoc = dto.isAdHoc
    }
}

export enum AssetInvoiceOutgoingType {
    sale = "sale",
    nonSale = "nonSale"
}

export interface IGetAssetInvoiceOutgoingByRequestDto {
    requestId: Guid
    requestNumber: string
    customerName: string
    totalAmount: IAmountWithCurrencyDto
    rentalFeeAmount?: IAmountWithCurrencyDto
    entities: IGetAssetInvoiceOutgoingDto[]
}

export default class AssetInvoiceOutgoingByRequest {
    requestId: Guid
    requestNumber: string
    customerName: string
    totalAmount: AmountWithCurrency
    rentalFeeAmount?: AmountWithCurrency
    entities: AssetInvoiceOutgoing[]

    constructor(dto: IGetAssetInvoiceOutgoingByRequestDto) {
        this.requestId = dto.requestId
        this.requestNumber = dto.requestNumber
        this.customerName = dto.customerName
        this.totalAmount = new AmountWithCurrency(dto.totalAmount)
        this.rentalFeeAmount = dto.rentalFeeAmount && new AmountWithCurrency(dto.rentalFeeAmount)
        this.entities = dto.entities.map(inv => new AssetInvoiceOutgoing(inv))
    }
}



